const sortSelectOptions = (optionA, optionB) => {
  if (optionA.disabled && !optionB.disabled) {
    return 1;
  }
  if (!optionA.disabled && optionB.disabled) {
    return -1;
  }
  if (typeof optionA.order !== "undefined" && typeof optionB.order === "undefined") {
    return -1;
  }
  if (typeof optionA.order === "undefined" && typeof optionB.order !== "undefined") {
    return 1;
  }
  if (typeof optionA.order === "undefined" && typeof optionB.order === "undefined" || optionA.order === optionB.order) {
    const labelA = optionA.label.toUpperCase();
    const labelB = optionB.label.toUpperCase();
    return labelA.localeCompare(labelB);
  }
  return (optionA.order || 0) - (optionB.order || 0);
};
export {
  sortSelectOptions
};
